import { Controller } from "@hotwired/stimulus";

// consider adding the scroll element as a value if we need to target a specific element

export default class extends Controller {
  connect() {
    document.addEventListener("turbo:render", this.handleScroll);
    document.addEventListener("turbo:before-cache", this.saveScrollPosition);
  }

  disconnect() {
    document.removeEventListener("turbo:render", this.handleScroll);
    document.removeEventListener("turbo:before-cache", this.saveScrollPosition);
  }

  handleScroll = () => {
    const main = document.querySelector(".main-content-area");

    requestAnimationFrame(() => {
      const savedPosition = sessionStorage.getItem("scroll-position");

      if (main && savedPosition) {
        main.scrollTo(0, parseInt(savedPosition, 10));

        // Remove the stored position so it's only used once
        sessionStorage.removeItem("scroll-position");
      }
    });
  };

  saveScrollPosition = () => {
    const main = document.querySelector(".main-content-area");

    if (main) {
      sessionStorage.setItem("scroll-position", main.scrollTop);
    }
  };
}
